import { StopDescriptionActions } from '../constants/stopDescriptionConstants'

export const setStopDescriptionOpen = isOpen => ({
    type: StopDescriptionActions.SET_IS_STOP_DESCRIPTION_OPEN,
    isOpen,
})

export const setSupplementalMediaType = mediaType => ({
    type: StopDescriptionActions.SET_SUPPLEMENTAL_MEDIA_TYPE,
    mediaType,
})
